import { useCallback, useState } from 'react';
import { move } from '@/utils/helpers/move';

type ReturnValues<T> = {
  moveItem: (dragIndex: number, dropIndex: number) => void;
  items: T[];
};

export const useItemsReordering = <T>(initialItems: T[]): ReturnValues<T> => {
  const [items, setItems] = useState<T[]>(initialItems);

  const moveItem = useCallback((dragIndex: number, dropIndex: number) => {
    setItems((prevItems) => {
      const result = move(prevItems, dragIndex, dropIndex);
      return result;
    });
  }, []);

  return { moveItem, items };
};
